// -> Google Analytics Reporting
export const sendEvent = (
  eventCategory,
  eventAction,
  eventLabel,
  eventValue,
  fieldsObject
) => {
  if (window.ga) {
    window.ga(
      'send',
      'event',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      fieldsObject
    );
  }
};
// -> Google Analytics Page Reporting
export const sendPage = page => {
  if (window.ga) {
    window.ga('send', 'pageview', page);
  }
};
